import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import { postUserVisit } from "components/app/App.slice";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { commonApiCallParam, resourceLinks } from "utils/UserAnalyticsUtils";
import Typography from "../Typography";

interface Props {
  title: string;
  url?: string;
  openInNewTab?: boolean;
  id: string | number;
  activeCard?: any;
  customResourceLink?: any;
}
export default function LinkButtons(props: Props) {
  const { title, url, openInNewTab } = props;
  const dispatch = useAppDispatch();
  const myPlanDetails: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);

  const handleClick = async (event: any, url: string | undefined, id: number | string, activeCard: any) => {
    if (url) {
      event.preventDefault();
      const param = commonApiCallParam(false, myPlanDetails);
      const resources = props.customResourceLink
        ? props.customResourceLink(url)
        : resourceLinks(param, activeCard, { url, id });
      await dispatch(postUserVisit(resources));
      if (openInNewTab) {
        window.open(url, "_blank", "noopener,noreferrer");
      } else {
        window.location.href = url;
      }
    }
  };

  return (
    <Box
      sx={{
        border: `solid 1px ${tokens.Border.General.Tertiary}`,
        borderRadius: "8px",
        padding: "8px 16px 8px 8px",
        marginY: "10px",
        minHeight: "56px",
        display: "flex",
        alignItems: "center",
        overflowWrap: "anywhere"
      }}
    >
      <Link
        sx={{ marginLeft: "20px" }}
        href={url}
        onClick={(e) => handleClick(e, url, props.id, props.activeCard)}
        underline="none"
      >
        <Typography variant="body2" color={tokens.Text.General.Color} showBold>
          {title}
        </Typography>
      </Link>
    </Box>
  );
}
